import ModalDialog from 'components/modal-dialog.dev';

function SuccessDialog(options = {}) {
    ModalDialog.call(this, {
        id: 'Tourist-leads-success-dialog',
        containerClass: 'Tourist-leads-success-dialog',
        descriptionHTML: `
            <div class="Tourist-leads-success-dialog__wrapper">
                <div class="Tourist-leads-success-dialog__icon">
                    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M16 2.66669C8.63999 2.66669 2.66666 8.64002 2.66666 16C2.66666 23.36 8.63999 29.3334 16 29.3334C23.36 29.3334 29.3333 23.36 29.3333 16C29.3333 8.64002 23.36 2.66669 16 2.66669ZM16 26.6667C10.12 26.6667 5.33332 21.88 5.33332 16C5.33332 10.12 10.12 5.33335 16 5.33335C21.88 5.33335 26.6667 10.12 26.6667 16C26.6667 21.88 21.88 26.6667 16 26.6667ZM22.12 10.1067L13.3333 18.8934L9.87999 15.4534L7.99999 17.3334L13.3333 22.6667L24 12L22.12 10.1067Z" fill="#00BC9B"/>
                    </svg>
                </div>
                <div class="Tourist-leads-success-dialog__content">
                    <div class="Tourist-leads-success-dialog__content-title">Спасибо!</div>
                    <div class="Tourist-leads-success-dialog__content-text">
                        Скоро свяжемся с вами и подберем подходящие варианты с учетом ваших пожеланий. Если у вас есть срочный вопрос, вы можете позвонить нам по номеру <a href="tel:88002225856">8 800 222-58-56</a>
                    </div>
                </div>
            </div>
        `,
        ...options,
    });
}

SuccessDialog.prototype = Object.create(ModalDialog.prototype);
Object.defineProperty(SuccessDialog.prototype, 'constructor', {
    value: SuccessDialog,
    enumerable: false,
    writable: true,
});

export default SuccessDialog;
